module.exports = __webpack_public_path__ + "img/eye.afe10b7c.svg";